import script from "./NavigationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationItem.vue?vue&type=script&setup=true&lang=js"

import "./NavigationItem.vue?vue&type=style&index=0&id=c830d06c&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c830d06c"]])

export default __exports__